import { ModalProps } from '@chakra-ui/react'
import { ReactElement } from 'react'

export enum FooterType {
  'FORM',
  'INFO',
}

export type ModalDefaultProps = ModalProps & {
  title?: string
  contentMaxW?: string | number
  footerComponent?: ReactElement
  footerType?: FooterType
  isLoadingSave?: boolean
  onButtonSaveClick?: () => void
  onButtonCancelClick?: () => void
  onButtonCloseClick?: () => void
  hideFooter?: boolean
}
